import { FONT_OPTIONS } from '../../theme/fonts';

type ColorFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export function ColorField({ label, value, onChange }: ColorFieldProps) {
  return (
    <label className="flex items-center gap-2">
      {label}
      <input type="color" value={value} onChange={(event) => onChange(event.target.value)} className="size-11" />
    </label>
  );
}

type FontSelectProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export function FontSelect({ label, value, onChange }: FontSelectProps) {
  return (
    <label className="flex flex-col gap-1 text-sm">
      {label}
      <select value={value} onChange={(event) => onChange(event.target.value)} className="min-h-11 rounded-lg border bg-transparent px-2">
        {FONT_OPTIONS.map((font) => (
          <option key={font.key} value={font.key}>
            {font.label}
          </option>
        ))}
      </select>
    </label>
  );
}
